var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-class"},[_c('v-tabs',{attrs:{"color":"black","dark":"","slider-color":"primary"}},[_c('v-tab',{key:'dashboard',attrs:{"ripple":""}},[_vm._v("Vue d'ensemble")]),_vm._v(" "),_c('v-tab-item',{key:'dashboard'},[_c('dashboard')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c8dc611","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bots/dashboard.vue
// module id = null
// module chunks = 